import type { Major } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

export const useAgentContext = (major: Major) => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'Graduate School',
    description:
      'How necessary graduate school is for careers in this major, with a rationale explanation',
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: 'Graduate School Necessity',
    display: 'Progress circle showing necessity level with rationale text alongside',
    detail: appStrings.modules.majors.graduateSchool.necessityInfo,
    data: {
      necessity: major.gradSchoolNecessity,
      rationale: major.gradSchoolNecessityRationale,
    },
  });
};
